module.exports = __webpack_public_path__ + "img/my-pic.b9210c56.jpg";